/**
 * Error types that can occur when starting screen recording
 */
export enum RecordingErrorType {
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  NOT_SUPPORTED = 'NOT_SUPPORTED', 
  ALREADY_RECORDING = 'ALREADY_RECORDING',
  UNKNOWN = 'UNKNOWN'
}

/**
 * Result type for recording start operations
 */
export interface RecordingStartResult {
  success: boolean;
  error?: {
    type: RecordingErrorType;
    message: string;
  };
}

/**
 * Interface for the ScreenRecordingBridgeClient defining its public API
 */
export interface IScreenRecordingBridgeClient {
  /**
   * Starts screen recording session
   * @param assessmentUUID The UUID of the assessment
   * @param userUUID The UUID of the user
   * @returns Promise that resolves with result indicating success/failure and error details
   */
  startRecording(assessmentUUID: string, userUUID: string): Promise<RecordingStartResult>;
  
  /**
   * Stops the current recording session
   * @returns Promise that resolves when recording has been fully stopped
   */
  stopRecording(): Promise<void>;
  
  /**
   * Checks if recording is in progress
   * @returns True if recording is active
   */
  isRecording(): boolean;
} 